import React from 'react';

const VIConSvg = () => (
  <svg width="12px" height="13px" viewBox="0 0 12 13" version="1.1">
    <title></title>
    <g id="Reactions---Admin-" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M5.99998569,12.3124969 C9.21013734,12.3124969 11.8124718,9.71016238 11.8124718,6.50001073 C11.8124718,3.28985908 9.21013734,0.687524587 5.99998569,0.687524587 C2.78983405,0.687524587 0.187499553,3.28985908 0.187499553,6.50001073 C0.187499553,9.71016238 2.78983405,12.3124969 5.99998569,12.3124969 Z M4.79730607,9.577663 L2.35981188,7.14016881 C2.21339652,6.99373056 2.21339652,6.75626622 2.35981188,6.60982797 L2.89015272,6.07951002 C3.03659097,5.93307177 3.2740553,5.93307177 3.42049355,6.07951002 L5.06248793,7.72152729 L8.57947784,4.20453738 C8.72593897,4.05807624 8.96340331,4.05807624 9.10981867,4.20453738 L9.64015951,4.73485533 C9.78657487,4.88129358 9.78657487,5.11875792 9.64015951,5.26519617 L5.32766979,9.57768589 C5.18120866,9.72410125 4.9437672,9.72410125 4.79730607,9.577663 Z"
        id=""
        fill="#35B840"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);

export default VIConSvg;
